import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  signal,
} from "@angular/core";
import { PaymentPageDetails } from "../shared/models/paymentdetails";
import { CreatePaymentReqest } from "../shared/models/makepaymentReq";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
  UntypedFormArray,
} from "@angular/forms";
import { PaymentService } from "../shared/services/payment.service";
import { ActivatedRoute, Router } from "@angular/router";
import { StorageService } from "src/app/core/helpers/storage-Service";
import { AuthService } from "src/app/core/auth/auth.service";
import { DataService } from "../shared/data.service";
import { flatMap, map } from "rxjs/operators";
import { CustomerInfo, PaymentMethodInfo } from "src/app/core/models/model";
import { ToastrService } from "ngx-toastr";
import { filterArr, isEmailValid } from "src/app/core/constants/constants";
import { TitleService } from "src/app/core/services/title.service";
import posthog from "posthog-js";

@Component({
  selector: "app-details-capture",
  templateUrl: "./details-capture.component.html",
  styleUrls: ["./details-capture.component.css"],
  standalone: false,
})
export class DetailsCaptureComponent implements OnInit {
  @Input() paymentDetails = new PaymentPageDetails();
  logo;
  altLogo = "";
  @Output() processPayment = new EventEmitter();
  isAmount: boolean = true;
  paymentItem: string;
  createPaymentReq = new CreatePaymentReqest();
  clientDetailsForm: UntypedFormGroup;
  rand: number;
  isLoading: boolean = false;
  paymentReference: string;
  paymentPageDetails = new PaymentPageDetails();
  isPageLoading: boolean = false;
  currency: string = "";
  menu = [
    { name: "Card", icon: "../../../assets/rexpay/card.svg" },
    { name: "USSD", icon: "../../../assets/rexpay/ussd.svg" },
    { name: "Bank", icon: "../../../assets/rexpay/card.svg" },
    { name: "Card", icon: "../../../assets/rexpay/ussd.svg" },
  ];

  customerInfo: CustomerInfo;
  paymentInfo: PaymentMethodInfo;

  field: any;
  public control: UntypedFormControl;

  public myForm: UntypedFormGroup;
  extraFields: any[];

  showError: boolean = false;
  whiteLabelInfo: any;
  isAmountFixed: boolean = false;

  errorMessage: string;
  showModal: boolean;

  header: string = "Error";

  showClickToPayInformationModal = signal(false);
  constructor(
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private payser: PaymentService,
    private router: Router,
    private storage: StorageService,
    private auth: AuthService,
    private dserv: DataService,
    private toastr: ToastrService,
    private titleService: TitleService,
  ) {
    this.paymentReference = route.snapshot.params["page"];
    if (this.paymentReference === "undefined") {
      const encoded = btoa("Invalid");
      this.router.navigate([`/failure/XXX/XXX/${encoded}`]);
    }
  }

  ngOnInit() {
    this.storage.removePaymentInfo();
    this.storage.removeAccessToken();
    this.setBaseurl();
    this.getRand();
    // this.getPageData();

    // this.getPageData();
    if (this.paymentReference) {
      // this.getAccessToken();
    }

    // this.initialieCustomerDetails();

    // this.initializeForm();

    this.getPageData();
  }

  setBaseurl() {
    this.payser.setBaseUrl();
  }

  getPageData() {
    this.payser
      .getPaymentPageDetails(this.paymentReference)
      .pipe(
        flatMap((val) =>
          this.payser.getCheckoutSettings(val.clientId).pipe(
            map((res) => {
              val["checkoutSettings"] = res;

              return val;
            }),
          ),
        ),
      )
      .subscribe(
        (res) => {
          this.isPageLoading = false;
          this.paymentPageDetails = res;
          this.isAmountFixed = res.isAmountFixed;

          this.customerInfo = {
            ...res["checkoutSettings"].customerInfo,
            // phoneNumberEnabled manually enabled because of the click-to-pay requirement
            phoneNumberEnabled: true,
          };
          this.whiteLabelInfo = res["checkoutSettings"].whiteLabelInfo;

          this.storage.saveAccessToken(res["checkoutToken"]);

          this.initializeForm();

          if (this.whiteLabelInfo) {
            this.titleService.updateTitle(
              this.paymentPageDetails.clientName + "Checkout",
            );
            const link: HTMLLinkElement =
              document.querySelector("link[rel*='icon']") ||
              (document.createElement("link") as HTMLLinkElement);
            link.type = "image/x-icon";
            link.rel = "icon";
            link.href = this.whiteLabelInfo.logoUrl;
            document.getElementsByTagName("head")[0].appendChild(link);
          }
          if (
            this.customerInfo &&
            this.customerInfo.additionalFields !== undefined
          ) {
            this.extraFields = this.customerInfo.additionalFields;
            this.extraFields = filterArr(this.extraFields);

            for (let index in this.extraFields) {
              if (this.extraFields.hasOwnProperty(index)) {
                const fieldName = this.getFieldName(this.extraFields[index]);
                const control = this.fb.control("");
                const additionalGroup = this.clientDetailsForm.get(
                  "additionalFields",
                ) as UntypedFormGroup;
                additionalGroup.addControl(fieldName, control);
              }
            }
          }

          if (!this.customerInfo) {
            this.customerInfo = {
              amountEnabled: true,
              emailAddressEnabled: true,
              phoneNumberEnabled: true,
            };
          }
          this.storage.storePaymentData(res["checkoutSettings"]);

          this.logo = this.paymentPageDetails.clientLogo;
          this.altLogo = this.paymentPageDetails.clientName;

          this.storage.saveClientDetails(res.clientName, res.clientId);
          this.storage.saveClientId(res.clientId);
          this.checkAmount();

          if (
            this.isAmountFixed &&
            this.paymentPageDetails.metaData.lineItem["itemAmount"]
          ) {
            let amount =
              this.paymentPageDetails.metaData.lineItem["itemAmount"];
            // amount = amount.toString();

            const formattedAmount = Number(amount).toLocaleString("en-NG", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            this.clientDetailsForm
              .get("clientDetails.amount")
              .patchValue(formattedAmount);
          } else if (
            !this.isAmountFixed &&
            this.paymentPageDetails.metaData.lineItem["itemAmount"]
          ) {
            let amount =
              this.paymentPageDetails.metaData.lineItem["itemAmount"];
            // amount = amount.toString();

            const formattedAmount = Number(amount).toLocaleString("en-NG", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            this.clientDetailsForm
              .get("clientDetails.amount")
              .patchValue(formattedAmount);
          } else {
            this.clientDetailsForm.get("clientDetails.amount").patchValue("");
          }

          this.clientDetailsForm
            .get("clientDetails.productName")
            .patchValue(this.paymentPageDetails.pageName);
          this.clientDetailsForm
            .get("clientDetails.itemCode")
            .patchValue(this.paymentPageDetails.metaData.lineItem["itemCode"]);
          this.clientDetailsForm
            .get("clientDetails.descr")
            .patchValue(this.paymentPageDetails.narration);

          this.currency = this.paymentPageDetails.currency;

          if (!this.currency) {
            this.currency = "NGN";
          }

          posthog.capture("checkout_page_viewed", {
            clientId: this.paymentPageDetails.clientId,
            clientName: this.paymentPageDetails.clientName,
            pageName: this.paymentPageDetails.pageName,
            currency: this.currency,
          });
        },
        (err) => {
          if (err) {
            this.showError = true;
          }
        },
      );
  }

  get metadata(): UntypedFormArray {
    return this.clientDetailsForm.get("metadata") as UntypedFormArray;
  }

  solveError(error) {
    if (error.error.responseMessage == undefined) {
      return "Error Validating payment";
    }
    return error.error.responseMessage;
  }

  allowNumericKeys(event: KeyboardEvent) {
    if (event.charCode < 43 || event.charCode > 57) {
      event.preventDefault();
    }
  }

  checkAmount() {
    if (
      !this.paymentPageDetails.metaData.lineItem["itemAmount"] ||
      this.paymentPageDetails.metaData.lineItem["itemAmount"] == 0
    ) {
      this.isAmount = false;
    }
    this.paymentItem =
      !this.paymentPageDetails.metaData.lineItem["itemName"] === null
        ? this.paymentPageDetails.metaData.lineItem["itemName"]
        : this.paymentPageDetails.metaData.lineItem["itemCode"];
  }

  createPayment() {
    this.setCreatePaymentItems();

    const data = this.createPaymentReq;
    // data.redirectUrl = `http://127.0.0.1:3300/pay/${this.createPaymentReq.reference}`;
    // data.callbackUrl = `http://127.0.0.1:3300/pay/${this.createPaymentReq.reference}`;

    const { extraFields, metadata, ...rest } = data;
    const updatedMetadata = { ...metadata, ...extraFields };
    const updatedData = { ...rest, metadata: updatedMetadata };

    this.createPaymentReq = updatedData;
    this.createPaymentReq.amount = parseInt(
      this.createPaymentReq.amount.toString().replace(/,/g, ""),
      10,
    );

    posthog.capture("continue_to_payment_clicked", {
      clientId: this.paymentPageDetails.clientId,
      currency: this.currency,
      amount: this.createPaymentReq.amount,
    });

    if (!this.createPaymentReq.metadata.firstName) {
      this.showModal = true;
      posthog.capture("checkout_validation_error", { field: "firstName" });
      return (this.errorMessage = "First Name is required");
    }

    if (!this.createPaymentReq.metadata.lastName) {
      this.showModal = true;
      posthog.capture("checkout_validation_error", { field: "lastName" });
      return (this.errorMessage = "Last Name is required");
    }

    if (!this.createPaymentReq.metadata.email) {
      this.showModal = true;
      posthog.capture("checkout_validation_error", { field: "email" });
      return (this.errorMessage = "Email is required");
    }
    if (!isEmailValid(this.createPaymentReq.metadata.email)) {
      this.showModal = true;
      posthog.capture("checkout_validation_error", { field: "emailInvalid" });
      return (this.errorMessage = "Kindly provide a valid email");
    }
    if (isNaN(this.createPaymentReq.amount)) {
      this.showModal = true;
      posthog.capture("checkout_validation_error", { field: "amount" });
      return (this.errorMessage = "Amount is invalid");
    }

    // Email is valid here — identify the payer so the session ties to them.
    posthog.identify(this.createPaymentReq.metadata.email, {
      email: this.createPaymentReq.metadata.email,
      firstName: this.createPaymentReq.metadata.firstName,
      lastName: this.createPaymentReq.metadata.lastName,
      phone: this.createPaymentReq.metadata.phone,
    });

    this.payser.createPayment(this.createPaymentReq).subscribe(
      async (data) => {
        let paymentRef = data["externalPaymentReference"];

        posthog.capture("payment_created", {
          clientId: this.paymentPageDetails.clientId,
          paymentReference: paymentRef,
          amount: this.createPaymentReq.amount,
          currency: this.currency,
        });

        this.router.navigate([`/pay/${paymentRef}`]);
        this.isLoading = false;

        const { email, amount, firstName, lastName } =
          this.createPaymentReq.metadata;
      },
      (error) => {
        this.isLoading = false;

        posthog.capture("payment_create_failed", {
          clientId: this.paymentPageDetails.clientId,
          amount: this.createPaymentReq.amount,
          currency: this.currency,
          reason: error?.error?.responseMessage,
        });

        this.errorMessage = error.error.responseMessage;
        this.showModal = true;
      },
    );
  }

  setCreatePaymentItems() {
    const clientDetails = this.clientDetailsForm.get("clientDetails").value;
    const extraFields = this.clientDetailsForm.get("additionalFields").value;

    this.createPaymentReq.amount =
      this.paymentPageDetails["metaData"] &&
      this.paymentPageDetails["metaData"]["lineItem"]["itemAmount"]
        ? this.paymentPageDetails["metaData"]["lineItem"]["itemAmount"]
        : clientDetails.amount;
    if (!this.isAmountFixed) {
      this.createPaymentReq.amount = clientDetails.amount;
    }
    this.createPaymentReq.clientId = this.paymentPageDetails.clientId;
    this.createPaymentReq.currency = this.currency;
    this.createPaymentReq.userId = clientDetails.email;
    this.createPaymentReq.reference = this.getRand();

    this.createPaymentReq.metadata = clientDetails;
    this.createPaymentReq.metadata.currency = this.currency;
    this.createPaymentReq.extraFields = extraFields;
  }

  getRand() {
    this.rand = Math.floor(Math.random() * 900);
    return `${Date.now().toString()}${this.rand}`;
  }

  get f() {
    return this.clientDetailsForm.controls;
  }

  getAccessToken() {
    this.isPageLoading = true;
    if (!this.storage.getAccessToken()) {
      this.auth.getAccessControl().subscribe(
        async (data) => {
          let dataToStore = await data;
        },
        (error) => {
          this.isPageLoading = false;
        },
      );
    } else {
      // this.getPageData();
      // this.getPaymentPageDetails();
    }
  }

  private isTokenExpired(token: string) {
    const expiry = JSON.parse(atob(token.split(".")[1])).exp;
    return expiry * 1000 > Date.now();
  }

  initializeForm() {
    this.clientDetailsForm = this.fb.group({
      clientDetails: this.fb.group({
        firstName: ["", Validators.required],
        lastName: ["", Validators.required],
        phone: ["", Validators.required],
        email: ["", Validators.required],
        amount: [{ value: "", disabled: this.isAmountFixed }],
        productName: [{ value: "", disabled: true }],
        itemCode: [{ value: "", disabled: true }],
        address: [""],
        descr: [{ value: "", disabled: true }],
        currency: [""],
      }),
      additionalFields: this.fb.group({}),
    });

    if (this.customerInfo) {
      // if (this.customerInfo.phoneNumberEnabled) {
      //   this.clientDetailsForm.get("phone").setValidators(Validators.required);
      // }
      // if (this.customerInfo.productNameEnabled) {
      //   this.clientDetailsForm.get("productName").enable();
      // }
      // if (this.customerInfo.itemCodeEnabled) {
      //   this.clientDetailsForm.get("itemCode").enable();
      // }
      // if (this.customerInfo.payerAddressEnabled) {
      //   this.clientDetailsForm
      //     .get("address")
      //     .setValidators(Validators.required);
      // }
      // if (this.customerInfo.productDescriptionEnabled) {
      //   this.clientDetailsForm.get("descr").enable();
      // }
    }
  }

  getFieldName(field: any): string {
    return Object.keys(field)[0];
  }

  get fields() {
    return this.clientDetailsForm.controls;
  }

  transform(value: string): string {
    const val = Object.keys(value)[0];

    if (!val) {
      return val;
    }
    const words = val.replace(/([a-z])([A-Z])/g, "$1 $2").split(" ");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1),
    );
    return capitalizedWords.join(" ");
  }

  close() {
    this.showModal = !this.showModal;
  }
}

// reference: "1586266904401172"
// clientId: "val.awe@gmail.com"
// paymentUrl: "https://sandbox.globalaccelerex.com:6038/15862671nnYEZs3acW"
// status: "CREATED"
